import React from 'react';

export default function DiscountCodes() {
  return (
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Discount_Codes__wCkn0g7YSmObqqszKIRF1w"
      height="640"
      title="Discount Codes"
      allowFullScreen
    />
  );
}
